import {CONSTANTS} from "../components/config/constants";
import {Users as UsersComponent} from '../components/user/users'

const Users = () => {
    return <UsersComponent no_users={'No System Users'} user_type={CONSTANTS.USER_TYPES.SYSTEM_USER}
                  page_title={'System Users'}/>
}
export default Users;
